import {
  ACCESS_LEVELS,
  AccessLevel,
  AuthRole,
  PermissionArea,
} from "api/common/types/auth.types";
import { AppPermission } from "app/role.types";

interface PermissionCheckParams {
  permissions: AppPermission;
  area: PermissionArea;
  access?: AccessLevel;
  role?: AuthRole;
}

export const checkPermissions = ({
  permissions: { role_permissions, role_type },
  area,
  access = ACCESS_LEVELS.READ,
  role,
}: PermissionCheckParams): boolean => {
  return role_permissions.some((p) => {
    return p.area === area && p[access] && (role ? role_type === role : true);
  });
};
